import { render, staticRenderFns } from "./SurveyLincImpex2025.vue?vue&type=template&id=2622f0c4&scoped=true"
import script from "./SurveyLincImpex2025.vue?vue&type=script&lang=js"
export * from "./SurveyLincImpex2025.vue?vue&type=script&lang=js"
import style0 from "./SurveyLincImpex2025.vue?vue&type=style&index=0&id=2622f0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622f0c4",
  null
  
)

export default component.exports